import { Autocomplete, Chip, TextField, Typography } from "@mui/material";
import type { FC } from "react";
import { useSellers } from "../useSellers";

interface Props {
  readonly sellerIds: string[];
  readonly onChange: (sellerIds: string[]) => void;
}

const SellerMultiSelect: FC<Props> = ({ sellerIds, onChange }) => {
  const sellers = useSellers();
  const selected = sellers.filter((seller) => sellerIds.includes(seller.id));
  return (
    <>
      <Autocomplete
        multiple
        size="small"
        options={sellers}
        value={selected}
        getOptionLabel={(seller) => seller.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(_, value) => onChange(value.map((seller) => seller.id))}
        renderValue={(value, getItemProps) =>
          value.map((seller, index) => {
            const { key, ...itemProps } = getItemProps({ index });
            return <Chip key={key} {...itemProps} label={seller.name} size="small" />;
          })
        }
        renderInput={(params) => <TextField {...params} label="Sprzedawca" placeholder="Wybierz sprzedawców" />}
      />
      <Typography variant="caption" sx={{ color: "text.secondary", mt: 0.5, display: "block" }}>
        Wyświetlani są przedstawiciele z działu sprzedaży
      </Typography>
    </>
  );
};

export default SellerMultiSelect;
